"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[644],{

/***/ 83675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ DiscountTotal; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+styled@11.13.0_@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1/node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(12851);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(75271);
// EXTERNAL MODULE: ./node_modules/.pnpm/swr@1.3.0_react@18.3.1/node_modules/swr/dist/index.mjs
var dist = __webpack_require__(75182);
// EXTERNAL MODULE: ./node_modules/.pnpm/@number-flow+react@0.3.0_react-dom@18.3.1_react@18.3.1/node_modules/@number-flow/react/dist/index.mjs + 1 modules
var react_dist = __webpack_require__(76935);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+design-system@5.3.3_@bucketplace+ui@1.0.9_@emotion+react@11.13.3_@emotion+styled_gws5alfnqy5ixwsabrkna3jsv4/node_modules/@bucketplace/design-system/dist/esm/foundation.js
var foundation = __webpack_require__(54939);
// EXTERNAL MODULE: ./src/styles/grids.ts
var grids = __webpack_require__(81213);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(83128);
;// CONCATENATED MODULE: ./src/promotions/components/Video.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var ATF_VIDEO_URL = 'https://prs.ohou.se/apne2/events/v1-307100170657920.mp4';
var ATF_POSTER_URL = 'https://prs.ohou.se/apne2/events/v1-307101245124673.png';
function Video() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Player, {
      preload: "metadata",
      loop: true,
      autoPlay: true,
      muted: true,
      controls: false,
      playsInline: true,
      poster: ATF_POSTER_URL,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        src: "".concat(ATF_VIDEO_URL, "#t=0.5"),
        type: "video/mp4"
      })
    })
  });
}

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1e4hhkb1"
} : 0)( true ? {
  name: "k2zp2x",
  styles: "overflow-x:clip"
} : 0);

var Player = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("video",  true ? {
  target: "e1e4hhkb0"
} : 0)( true ? {
  name: "1gm0vw5",
  styles: "width:100%;display:block;transform:scale(1.02)"
} : 0);
;// CONCATENATED MODULE: ./src/promotions/components/DiscountTotal.tsx


function DiscountTotal_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var EVENT_API_PATH = '/api/promotions';
// 시간 단위
var DISPLAY_HOUR = 9; // 시간을 밀리초 단위로 변환

var DISPLAY_TIME = DISPLAY_HOUR * 60 * 60 * 1000;

var fetcher = function fetcher(url) {
  return fetch(url).then(function (res) {
    return res.json();
  });
};

function DiscountTotal(_ref) {
  var _discountTotalData$bl, _discountTotalData$bl2;

  var promotionId = _ref.promotionId,
      showDiscountTotal = _ref.showDiscountTotal,
      startAt = _ref.startAt;

  var _useState = (0,react.useState)(-1),
      timeGap = _useState[0],
      setTimeGap = _useState[1];

  var interval = (0,react.useRef)();

  var _useSWR = (0,dist/* default */.ZP)("".concat(EVENT_API_PATH, "/").concat(promotionId, "/discount-total"), fetcher, {
    refreshInterval: 1000,
    isPaused: function isPaused() {
      return !showDiscountTotal;
    }
  }),
      discountTotalData = _useSWR.data,
      discountTotalError = _useSWR.error;

  (0,react.useLayoutEffect)(function () {
    if (!startAt) {
      return null;
    }

    var compareDisplayDateToDuration = function compareDisplayDateToDuration() {
      // 블랙프라이데이 시작 시간 + n시간
      var startTime = new Date(new Date(startAt).getTime() + DISPLAY_TIME);
      var currentTime = new Date();
      var diff = startTime.getTime() - currentTime.getTime();

      if (currentTime >= startTime || diff <= 0) {
        setTimeGap(0);
        clearInterval(interval.current);
      } else {
        setTimeGap(diff);
      }
    };

    compareDisplayDateToDuration();
    interval.current = window.setInterval(compareDisplayDateToDuration, 1000);
    return function () {
      return clearInterval(interval.current);
    };
  }, [startAt]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GridItem, {
      column: {
        mobile: 'full',
        tablet: 'full',
        laptop: 9
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Video, {}), showDiscountTotal && !discountTotalError && timeGap <= 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DiscountContainer, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
          children: "\uBE14\uB799 \uD504\uB77C\uC774\uB370\uC774 \uB204\uC801 \uD560\uC778 \uAE08\uC561"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PriceContainer, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PriceText, {
            style: {
              marginRight: '1.3px'
            },
            children: "\uCD1D"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PriceWrapper, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_dist/* default */.ZP, {
              value: Number((_discountTotalData$bl = discountTotalData === null || discountTotalData === void 0 ? void 0 : (_discountTotalData$bl2 = discountTotalData.blackFridayTotalDiscountAmount) === null || _discountTotalData$bl2 === void 0 ? void 0 : _discountTotalData$bl2.totalDiscountAmount) !== null && _discountTotalData$bl !== void 0 ? _discountTotalData$bl : '0'),
              spinTiming: {
                duration: 300
              }
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PriceText, {
            style: {
              marginLeft: '1.3px'
            },
            children: "\uC6D0"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
          children: "\uD61C\uD0DD \uAE08\uC561 \uC720\uC758 \uC0AC\uD56D\uC740 \uD558\uB2E8\uC744 \uCC38\uC870\uD558\uC138\uC694."
        })]
      })]
    })
  });
}

var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e16nphk57"
} : 0)("display:flex;flex-wrap:wrap;max-width:", foundation.B.desktop, "px;margin:0 auto;padding:0 60px;", foundation.M.max('tablet', "\n    padding: 0;\n  "), ";" + ( true ? "" : 0));

var GridItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e16nphk56"
} : 0)("position:relative;margin:0 auto;", function (_ref2) {
  var column = _ref2.column;
  return (0,grids/* cssColumn */.XG)(column);
}, ";" + ( true ? "" : 0));

var DiscountContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e16nphk55"
} : 0)("display:flex;align-items:center;flex-direction:column;padding:30px 12px;font-family:Pretendard;font-weight:500;background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.base.neutral700;
}, ";" + ( true ? "" : 0));

var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e16nphk54"
} : 0)("color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.background;
}, ";font-size:15px;font-weight:500;line-height:15px;margin-bottom:4px;" + ( true ? "" : 0));

var PriceContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e16nphk53"
} : 0)( true ? {
  name: "wx18ik",
  styles: "display:flex;align-items:center;margin-bottom:7px"
} : 0);

var PriceText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e16nphk52"
} : 0)( true ? {
  name: "1w128b0",
  styles: "color:#1AA7FF;font-size:26px;font-weight:500;line-height:normal"
} : 0);

var PriceWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e16nphk51"
} : 0)( true ? {
  name: "tt85rw",
  styles: "display:flex;color:#1AA7FF;font-family:Quantico,sans-serif;font-weight:400;font-size:30px;line-height:0px;letter-spacing:-1.2px"
} : 0);

var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e16nphk50"
} : 0)( true ? {
  name: "mahjkp",
  styles: "color:#3D3D3D;text-align:center;font-size:11.8px;font-style:normal;font-weight:400;line-height:16px"
} : 0);

/***/ }),

/***/ 32315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ usePlatformInfo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75271);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17966);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);



/**
 * 유저의 플랫폼 정보를 반환합니다.
 */
var usePlatformInfo = function usePlatformInfo() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  var _router$query = router.query,
      appOsType = _router$query.os_type,
      version = _router$query.version;
  var osType = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var rtn = appOsType;

    if ( false || rtn) {
      return rtn;
    }

    if (sessionStorage['os_type']) {
      return sessionStorage['os_type'];
    }

    if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1 || /iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      return 'mWebIOS';
    } else if (/Android/i.test(navigator.userAgent)) {
      return 'mWebAndroid';
    } else {
      return 'Web';
    }
  }, [appOsType]);
  var appVersion = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var _sessionStorage$os_ve;

    if ( false || version) return version;
    return (_sessionStorage$os_ve = sessionStorage['os_version']) !== null && _sessionStorage$os_ve !== void 0 ? _sessionStorage$os_ve : null;
  }, [version]);
  return {
    osType: osType,
    appVersion: appVersion,
    isMobile: osType !== 'Web',
    isInApp: osType === 'iOS' || osType === 'Android'
  };
};

/***/ })

}]);